// extracted by mini-css-extract-plugin
export default {"create-report-columns-popup":"CreateReportColumnsPopup_create-report-columns-popup__HKn2W","popup-header":"CreateReportColumnsPopup_popup-header__go6hf"};